export default [
  {
    id: 'NUNCA',
    descricao: 'NUNCA',
    valor: 0,
    escala: 0,
    rating: 1,
  },
  {
    id: 'RARAMENTE',
    descricao: 'RARAMENTE',
    valor: 1,
    escala: 25,
    rating: 2,
  },
  {
    id: 'AS_VEZES',
    descricao: 'ÀS VEZES',
    valor: 2,
    escala: 50,
    rating: 3,
  },
  {
    id: 'MUITAS_VEZES',
    descricao: 'MUITAS VEZES',
    valor: 3,
    escala: 75,
    rating: 4,
  },
  {
    id: 'SEMPRE',
    descricao: 'SEMPRE',
    valor: 4,
    escala: 100,
    rating: 5,
  },
];
